import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
    const measurementId = 'G-Y2E7YE5SSH';
    
    ReactGA.initialize(measurementId, {
        gaOptions: {
            siteSpeedSampleRate: 100,
        },
        gtagOptions: {
            send_page_view: false, // We'll manually track page views for better control
        },
    });
    
    if (process.env.NODE_ENV === 'development') {
        console.log('Google Analytics initialized with ID:', measurementId);
    }
};

// Track page views
export const trackPageView = (path, title) => {
    ReactGA.send({ 
        hitType: 'pageview', 
        page: path,
        title: title || document.title 
    });
    
    if (process.env.NODE_ENV === 'development') {
        console.log('GA Page View:', path, title);
    }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
    ReactGA.event(eventName, eventParams);
    
    if (process.env.NODE_ENV === 'development') {
        console.log('GA Event:', eventName, eventParams);
    }
};

// Event name constants for consistency
export const GA_EVENTS = {
    CLICK_CREATE_ACCOUNT: 'click_create_account',
    VIEW_SUBSCRIPTION_MANAGEMENT: 'view_subscription_management',
    CLICK_PRICING_TIER: 'click_pricing_tier',
};

